import sortBy from 'lodash/sortBy';
import Router from 'next/router';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import StarRatings from 'react-star-ratings';

import FitmentVerification from '../../components/product/FitmentVerification';
import { getDistanceMessage } from '../../services';
import Reviews from '../category/Reviews';
import { initSingleLineProposition } from '../checkout/Payment/AffirmFunctions.js';
import Loading from '../loading';
import CampaignHypherlink from './CampaignHypherlink';
const formatCurrency = require('format-currency');
import { markdownify } from '../../utils';

const options = [
	{ value: 'Price', label: 'Price' },
	{ value: 'DistanceMiles', label: 'Distance' },
	{ value: 'Rating', label: 'Rating' },
];

const customStyles = {
	menuList: (provided, state) => ({
	  ...provided,
	  // maxHeight: '200px',
	}),
	control: (provided, state) => ({
	  ...provided,
	  height: "45px",
	  borderRadius: "3px",
	  border: "1px solid #fff",
	  backgroundColor: "#fff !important",
	}),
  
	valueContainer: (provided, state) => ({
	  ...provided,
	  height: "45px",
	  padding: "0 6px",
	}),
  
	input: (provided, state) => ({
	  ...provided,
	  margin: "0px",
	}),
  
	indicatorsContainer: (provided, state) => ({
	  ...provided,
	  height: "45px",
	}),
  };

class AddToCartSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			quantity: 1,
			selectedProviderId: 0,
			selectedLocation: 0,
			selectedLocationArray: [],
			UserLocationIndexLookup: 0,
			selectedService: 0,
			integratedLocationsHeight: null,
			modalOpen: false,
			sortBy: { value: '', label: '' },
			addingToCart: false,
		};
	}

	setSelectedLocation = e => {
		// Pop to front of array
		e.Index = this.state.UserLocationIndexLookup;
		this.renderValue(e);
	};

	showIntegratedLocations(value) {
		this.setState({
			showIntegratedLocations: value,
		});
	}

	getLocations = (e, index) => {
		this.setState({
			selectedLocationArray: e,
			UserLocationIndexLookup: index,
			modalOpen: true,
		});
	};

	renderValue = async e => {
		this.setState({
			selectedService: e.ServiceId,
			selectedProviderId: e.ProviderId,
		});

		this.props.setSelectedProvider({
			providerId: e.ProviderId,
			serviceId: e.ServiceId,
		});

		if (this.props.isCart) {
			this.props.updateSelectedProvider(this.props.item.id, e.provider, e.ServiceId);
		}

		// FIXME: Forcing parent component to re render once store gets new state
		setTimeout(() => {
			this.props.forceState();
		}, 0);
	};

	callNumber(number) {
		//  Add Analytics to Post Out CALL HERE or TRACKING ( TO-DO )
		window.open(`tel:${number}`);
	}

	LinkHref(href) {
		if (href.startsWith('http')) {
			// External Affliate URL
			// TODO: Add Analytics to Post Out URL HERE or TRACKING
			window.location.href = href;
		} else {
			// Client Side Site URL
			Router.push(href);
		}
	}

	componentDidMount() {
		this.setState({
			initialCartQty:
				this.props.cartlist && this.props.cartlist.cart.length > 0 ? this.props.cartlist.cart[0].qty : 0,
		});

		let id = `singleItemAffirmProposition_${this.props.item.id}`;
		let item = this.props.item;
		setTimeout(() => {
			initSingleLineProposition(affirm, item, id);
			affirm.ui.ready(function () {
				affirm.ui.refresh();
			});
		}, 0);
	}

	async BuyNow(item, quantity) {
		this.setState({ addingToCart: true });
		await this.props.addToCartClicked(item, quantity > 0 ? quantity : 1); // 1 is minimum quantity
	}

	onOpenModal = () => {
		this.setState({ modalOpen: true });
	};

	onCloseModal = () => {
		this.setState({ modalOpen: false });
	};

	render() {
		var {
			cartlist,
			optionalServiceArray,
			serviceArray,
			selectedServiceIndex,
			item,
			addToWishlistClicked,
			compact,
			dontShowBuyButton,
			providerLoading,
			isCart,
			symbol,
			provider,
			reviews,
		} = this.props;
		const latestCartQty = cartlist && cartlist.cart.length > 0 ? cartlist.cart[0].qty : 0;

	
		if (serviceArray.length == 0) {
			return '';
		}
		const sortedOptions =
			this.state.sortBy.value === 'Rating'
				? sortBy(this.state.selectedLocationArray, [this.state.sortBy.value]).reverse()
				: sortBy(this.state.selectedLocationArray, [this.state.sortBy.value]);

	 
		return (
			<div
				className={`add-to-cart-selector ${compact ? 'compact' : ''}`}
				ref={locationsContainer => (this.locationsContainer = locationsContainer)}>
				<div className="product-options-container">
					{optionalServiceArray.length > 0
						? optionalServiceArray.map((option, index) => {
								return (
									<div key={index} className={option.isShowPriceOnly && 'show-price-only'}>
										<button
											disabled={option.isShowPriceOnly && 'show-price-only'}
											key={index}
											className={`btn ${
												index === this.props.selectedServiceIndex ? 'active' : ''
											}`}
											onClick={e => {
												this.renderValue({
													Index: option.Index,
													ProviderId: option.Locations[0].ProviderId,
													ServiceId: option.ServiceId,
													provider: option.Locations[0],
												});
											}}>
											<div className="primary">
												<div className="icon">
													<i className="checked far fa-check-circle"></i>
													<i className="unchecked far fa-circle"></i>
												</div>

												<div className="content">
													<span className="service-description">{option.ServiceDescription}</span>
													<span className="about-location">
														{option.ServiceLabel}
														{option.FeeMessage ? ` - ${option.FeeMessage}` : ''}
													</span>
													<span className="about-location">{option.Name}</span>
													<span className="about-location">{option.ProviderMessage}</span>

													<div className="reviews-cont">
														{reviews && reviews?.stats && (
															<span className="about-location star-details">
																<StarRatings
																	numberOfStars={5}
																	rating={parseFloat(reviews.stats.average_rating)}
																	starDimension="12px"
																	starSpacing="0"
																	starRatedColor="#FF9966"
																	starEmptyColor="grey"
																/>

																<span className="numerical-rating-container">
																	<span className="numerical-rating ml-1">
																		({reviews.stats.average_rating})
																	</span>
																	<span className="numerical-rating ml-1">
																		{reviews.stats.total_reviews} Reviews
																	</span>
																</span>
															</span>
														)}
													</div>
												</div>
											</div>

											{serviceArray[index].ServiceId != 2 &&
											serviceArray[index].ServiceId != 3 &&
											serviceArray[index].ServiceId != 4 ? (
												<div
													className="secondary"
													onClick={e =>
														this.getLocations(
															serviceArray[index].Locations,
															selectedServiceIndex
														)
													}>
													<span>
														{option.ImageUrl ? (
															<img
																className="provider-logo"
																src={option.ImageUrl}
																alt=""
															/>
														) : (
															<i className="fad fa-map-marked-alt"> </i>
														)}

														<br />
														<small className="free-installation"> Change</small>
													</span>
												</div>
											) : (
												<div className="secondary">
													<span onClick={() => this.props.showProviderDetails()}>
														{!providerLoading && (
															<i
																className={
																	option.iconClassName
																		? option.iconClassName
																		: 'fad fa-shipping-fast'
																}></i>
														)}

														{providerLoading && (
															<i className="fas fa-circle-notch fa-spin"></i>
														)}
														<br />
														<small className="free-installation">
															{!providerLoading && 'Details'}

															{providerLoading && 'Loading'}
														</small>
													</span>
												</div>
											)}
										</button>
									</div>
								);
						  })
						: ''}
				</div>
				<div id="prices">
					<p
						className="affirm-as-low-as"
						data-page-type="product"
						data-amount={this.props.item.price * 100}></p>
				</div>

				{!dontShowBuyButton ? (
					<div className="add-to-cart-container">
						<div className="primary">
							{!compact && (
								<div className="quantity-container">
									<input
										disabled={serviceArray[this.props.selectedServiceIndex].DisableCart}
										type="number"
										name="quantity"
										min="1"
										max="99"
										placeholder={this.state.quantity > 0 ? this.state.quantity : 1}
										onChange={e => this.setState({ quantity: e.target.value })}
										className="form-control input-number"
									/>
								</div>
							)}

							<button
								disabled={serviceArray[this.props.selectedServiceIndex].DisableButton || this.props.isLoading}
								className={`btn cart ${(serviceArray[this.props.selectedServiceIndex].DisableButton || this.props.isLoading) && 'disabled'}`}
								onClick={() =>
									serviceArray[this.props.selectedServiceIndex].ServiceId == 5
										? this.callNumber(
												serviceArray[this.props.selectedService]?.PhoneNumber
													? serviceArray[this.props.selectedService].PhoneNumber
													: '8002288379'
										  )
										: serviceArray[this.props.selectedServiceIndex].ServiceId == 10
										? this.LinkHref(serviceArray[this.props.selectedServiceIndex].ServiceURL)
										: this.BuyNow(item, this.state.quantity)
								}>
								{!serviceArray[this.props.selectedServiceIndex].DisableCart && (
									<span>
										{this.state.initialCartQty === latestCartQty && this.state.addingToCart ? (
											<Loading />
										) : (
											<i
												className={
													serviceArray[this.props.selectedServiceIndex].iconClassName
														? serviceArray[this.props.selectedServiceIndex].iconClassName
														: 'fad fa-cart-plus'
												}></i>
										)}

										{serviceArray[this.props.selectedServiceIndex].ButtonLabel}
									</span>
								)}

								{serviceArray[this.props.selectedServiceIndex].DisableCart && (
									<span>
										<i
											className={
												serviceArray[this.props.selectedServiceIndex].iconClassName
													? serviceArray[this.props.selectedServiceIndex].iconClassName
													: 'fas fa-phone-alt'
											}></i>
										{serviceArray[this.props.selectedServiceIndex].ButtonLabel}
									</span>
								)}
							</button>
						</div>

						{item.fitmentMessage && (
							<div className="alert alert-primary mt-2" role="alert">
								{item.fitmentMessage}
							</div>
						)}
					</div>
				) : (
					<></>
				)}

				{item.campaigns.map((item, index) => {
					if (item.campaignType === 3) {
						if (isCart) {
							return item.discountAmount > 0 && <CampaignHypherlink key={index} campaign={item} />;
						} else {
							return <CampaignHypherlink key={index} campaign={item} />;
						}
					}
				})}
				{/* Render only on Vehicle Batteries Car or Truck */}
				{this.props.showFitment &&
					(this.props.item.categoryId === 2 || this.props.item.categoryId === 205712) && (
						<FitmentVerification
							formTitle={``}
							subtitle={'Verify fitment with your vehicle'}
							type="single-product-fitment"
							idToCompare={item.bigCommerceId}
							categorySlug={item.category.urlSlug}
						/>
					)}

				{/* {!dontShowBuyButton && item?.shortDescription && !compact && (
					<div className="description mt-2">
						<p>{markdownify(item?.shortDescription)}</p>
					</div>
				)} */}

				<Modal
					classNames={{
						modal: `change-location-modal`,
					}}
					open={this.state.modalOpen}
					onClose={this.onCloseModal}>
					<div className="location-items-integrated">
						<div className="header">
							<div className="info">
								<h3>Available Locations</h3>
								<div className="button-container">
									<button className="btn" onClick={() => this.setState({ modalOpen: false })}>
										<i className="fas fa-times" aria-hidden="true"></i>
										Close
									</button>
								</div>
							</div>

							<div className="controls">
								<span className="title">Sort By: </span>
								<Select
									styles={customStyles}
									placeholder="Default"
									options={options}
									onChange={value => this.setState({ sortBy: value })}
								/>
							</div>
						</div>

						<div className="body">
							{sortedOptions.map((locations, index) => {
								const msrp = locations.msrp ? locations.msrp : Math.round(locations.Price * 1.15, 2);

								return (
									<div
										key={index}
										className={`item ${
											provider.providerId === locations.ProviderId ? 'selected' : ''
										}`}
										onClick={() => {
											this.setState({ modalOpen: false });
											this.setSelectedLocation(locations);
										}}>
										<span className="selected-label">
											<i className="fas fa-check"></i> Selected
										</span>
										<div className="section first">
											<div className="content">
												<div className="body">
													<p>
														<i className="fas fa-map-marker-alt mr-1"></i>
														{`${getDistanceMessage(locations.DistanceMiles)}`}
													</p>
													<p>{locations.Address1}</p>
													<p>
														{`${locations.City}, ${locations.State} , ${locations.ZipPostalCode}`}
													</p>
												</div>

												{provider.providerId !== locations.ProviderId && (
													<div className="footer">
														<div className="footer-item">
															<button
																className="btn location"
																onClick={() => {
																	this.setState({ modalOpen: false });
																	this.setSelectedLocation(locations);
																}}>
																<i className="fad fa-location"></i>
																Select Location
															</button>
														</div>
													</div>
												)}
											</div>
										</div>

										<div className="section second">
											<div className="info">
												<img width="64px" src={locations.ImageUrl} alt="" />
												<h5>{locations.Name}</h5>
											</div>

											<div className="price">
												<span className="ex-price">
													<del>
														{symbol}
														{formatCurrency(msrp)}
													</del>
												</span>
												<span className="price">
													{symbol}
													{formatCurrency(locations.Price)}
												</span>
												<div className="rating">
													<StarRatings
														numberOfStars={5}
														rating={parseFloat(reviews.stats.average_rating)}
														starDimension="15px"
														starSpacing="0"
														starRatedColor="#FF9966"
														starEmptyColor="grey"
													/>
													<span>
														({reviews.stats.average_rating}) - {reviews.stats.total_reviews}{' '}
														Reviews
													</span>
												</div>
											</div>
										</div>

										<button
											className="btn location mobile-only"
											onClick={() => {
												this.setState({ modalOpen: false });
												this.setSelectedLocation(locations);
											}}>
											<i className="fad fa-location"></i>
											Select Location
										</button>
									</div>
								);
							})}
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	products: state.category.products,
});

export default connect(mapStateToProps, null)(AddToCartSelector);
